import React from 'react';
import styled from 'styled-components';

interface MapInfoHeaderProps {
    layerName: string;
    selectedSlotDate: string;
    selectedSlotTime: string;
    currentLocation: string;
}

export const MapInfoHeader = ({layerName, selectedSlotDate, selectedSlotTime, currentLocation}: MapInfoHeaderProps) => {
    return (
        <Container>
            <InfoText aria-label={`Map Layer: ${layerName}`}>{layerName} </InfoText>
            <Separator/>
            <InfoText aria-label={`Animation Date: ${selectedSlotDate}`}>{selectedSlotDate} </InfoText>
            <Separator/>
            <InfoText aria-label={`Animation Time: ${selectedSlotTime}`}>{selectedSlotTime} </InfoText>
            <Separator/>
            <InfoText aria-label={`Selected Location: ${currentLocation}`}>{currentLocation}</InfoText>
        </Container>
    );
};


const Container = styled.h1`
    margin: 0;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 24px;
    width: 100vw;
    border-top: 1px solid #CBD0D3;
    padding: 4px 8px;
    background: #FFFFFF;
    justify-content: center;
`;
const InfoText = styled.span`
    color: #555555;
    font: 600 13px "Source Sans Pro", sans-serif;
    line-height: 16px;
    white-space: nowrap;

    &:last-child {
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;
const Separator = styled(InfoText)`
    &::after {
        content: '|';
        margin: 0 8px;
    }
`;
